/*
 * 4mypet installation postcode lookup table.
 *
 * Source: cleaned installation workbook (125 UK postcode areas:
 *   103 fixed-price, 22 quote-only).
 *
 * Quote-only areas (no online install price):
 *   AB BT DD DG EH FK G GY HS IM IV JE KA KW KY ML PA PH QC TD TR ZE
 *
 * IMPORTANT: The full per-area 1-man / 2-man prices come from the
 *   installation workbook. The verified QA examples in the dev brief
 *   are populated below (AL, CB, DA). Every other priced area currently
 *   uses the cheapest band as a placeholder — the merchant MUST overwrite
 *   each with the band Paul has signed off before launch.
 */

window.FMP_INSTALL_POSTCODES = {
  /* ── Quote-only areas (22) ─────────────────────────────────────── */
  AB: { quoteOnly: true, region: "Scotland" },
  BT: { quoteOnly: true, region: "Northern Ireland" },
  DD: { quoteOnly: true, region: "Scotland" },
  DG: { quoteOnly: true, region: "Scotland" },
  EH: { quoteOnly: true, region: "Scotland" },
  FK: { quoteOnly: true, region: "Scotland" },
  G:  { quoteOnly: true, region: "Scotland" },
  GY: { quoteOnly: true, region: "Channel Islands" },
  HS: { quoteOnly: true, region: "Scotland" },
  IM: { quoteOnly: true, region: "Isle of Man" },
  IV: { quoteOnly: true, region: "Scotland" },
  JE: { quoteOnly: true, region: "Channel Islands" },
  KA: { quoteOnly: true, region: "Scotland" },
  KW: { quoteOnly: true, region: "Scotland" },
  KY: { quoteOnly: true, region: "Scotland" },
  ML: { quoteOnly: true, region: "Scotland" },
  PA: { quoteOnly: true, region: "Scotland" },
  PH: { quoteOnly: true, region: "Scotland" },
  QC: { quoteOnly: true, region: "Other" },
  TD: { quoteOnly: true, region: "Scottish Borders" },
  TR: { quoteOnly: true, region: "South West" },
  ZE: { quoteOnly: true, region: "Scotland" },

  /* ── Priced areas (103) ────────────────────────────────────────── */
  /* VERIFIED from QA brief: */
  AL: { quoteOnly: false, oneMan: 345, twoMan: 445, region: "East of England" },
  CB: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "East of England" },
  DA: { quoteOnly: false, oneMan: 346, twoMan: 446, region: "Greater London" },

  /* PLACEHOLDER — merchant to overwrite with workbook bands: */
  B:  { quoteOnly: false, oneMan: 335, twoMan: 435, region: "West Midlands" },
  BA: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "South West" },
  BB: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "North West" },
  BD: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "Yorkshire" },
  BH: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "South West" },
  BL: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "North West" },
  BN: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "South East" },
  BR: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "Greater London" },
  BS: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "South West" },
  CA: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "North West" },
  CF: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "Wales" },
  CH: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "North West" },
  CM: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "East of England" },
  CO: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "East of England" },
  CR: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "Greater London" },
  CT: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "South East" },
  CV: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "West Midlands" },
  CW: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "North West" },
  DE: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "East Midlands" },
  DH: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "North East" },
  DL: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "North East" },
  DN: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "Yorkshire" },
  DT: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "South West" },
  DY: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "West Midlands" },
  E:  { quoteOnly: false, oneMan: 335, twoMan: 435, region: "Greater London" },
  EC: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "Greater London" },
  EN: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "Greater London" },
  EX: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "South West" },
  FY: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "North West" },
  GL: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "South West" },
  GU: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "South East" },
  HA: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "Greater London" },
  HD: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "Yorkshire" },
  HG: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "Yorkshire" },
  HP: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "South East" },
  HR: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "West Midlands" },
  HU: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "Yorkshire" },
  HX: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "Yorkshire" },
  IG: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "Greater London" },
  IP: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "East of England" },
  KT: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "South East" },
  L:  { quoteOnly: false, oneMan: 335, twoMan: 435, region: "North West" },
  LA: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "North West" },
  LD: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "Wales" },
  LE: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "East Midlands" },
  LL: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "Wales" },
  LN: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "East Midlands" },
  LS: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "Yorkshire" },
  LU: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "East of England" },
  M:  { quoteOnly: false, oneMan: 335, twoMan: 435, region: "North West" },
  ME: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "South East" },
  MK: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "South East" },
  N:  { quoteOnly: false, oneMan: 335, twoMan: 435, region: "Greater London" },
  NE: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "North East" },
  NG: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "East Midlands" },
  NN: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "East Midlands" },
  NP: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "Wales" },
  NR: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "East of England" },
  NW: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "Greater London" },
  OL: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "North West" },
  OX: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "South East" },
  PE: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "East of England" },
  PL: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "South West" },
  PO: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "South East" },
  PR: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "North West" },
  RG: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "South East" },
  RH: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "South East" },
  RM: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "Greater London" },
  S:  { quoteOnly: false, oneMan: 335, twoMan: 435, region: "Yorkshire" },
  SA: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "Wales" },
  SE: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "Greater London" },
  SG: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "East of England" },
  SK: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "North West" },
  SL: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "South East" },
  SM: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "Greater London" },
  SN: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "South West" },
  SO: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "South East" },
  SP: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "South West" },
  SR: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "North East" },
  SS: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "East of England" },
  ST: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "West Midlands" },
  SW: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "Greater London" },
  SY: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "West Midlands" },
  TA: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "South West" },
  TF: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "West Midlands" },
  TN: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "South East" },
  TQ: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "South West" },
  TS: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "North East" },
  TW: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "Greater London" },
  UB: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "Greater London" },
  W:  { quoteOnly: false, oneMan: 335, twoMan: 435, region: "Greater London" },
  WA: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "North West" },
  WC: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "Greater London" },
  WD: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "East of England" },
  WF: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "Yorkshire" },
  WN: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "North West" },
  WR: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "West Midlands" },
  WS: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "West Midlands" },
  WV: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "West Midlands" },
  YO: { quoteOnly: false, oneMan: 335, twoMan: 435, region: "Yorkshire" }
};
